import { StoreModuleStatus } from "@constants";
import { useGetDocument } from "./useGetDocument";

export function useStoreModuleStatus() {
  const [fetchedModuleStatus] = useGetDocument<StoreModuleStatus>(
    "store",
    "moduleStatus",
  );
  return fetchedModuleStatus;
}
